import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { ExternalLinkIcon } from '@domain-group/fe-co-icon';
import { Modal as DesignSystemModal } from '@domain-group/fe-co-allhomes-design-system';
var UhdIcon = "https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-pa-allhomes-listing-details/static/icon-4k_5b706cd3.png";
var ConcurrencyIcon = "https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-pa-allhomes-listing-details/static/icon-concurrency_cd577307.png";
var GamingIcon = "https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-pa-allhomes-listing-details/static/icon-gaming_476f938d.png";
var VideoIcon = "https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-pa-allhomes-listing-details/static/icon-video_9924b87c.png";
var FilesIcon = "https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-pa-allhomes-listing-details/static/icon-files_e398bc6d.png";
import * as styles from './modal.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var Modal = _ref => {
  var show = _ref.show,
    onClose = _ref.onClose,
    brand = _ref.brand,
    brandName = _ref.brandName;
  var isFast = brand === 'ULTRAFAST' || brand === 'FAST';
  var getListItem = (icon, content) => ___EmotionJSX("div", {
    css: styles.listItem
  }, ___EmotionJSX("img", {
    src: icon,
    alt: ""
  }), ___EmotionJSX("span", null, content));
  var getFastSection = () => ___EmotionJSX("section", {
    css: styles.section
  }, ___EmotionJSX("div", {
    css: styles.heading
  }, brandName, " is designed for:"), brand === 'ULTRAFAST' ? ___EmotionJSX(Fragment, null, getListItem(UhdIcon, 'Concurrent 4K video streaming'), getListItem(ConcurrencyIcon, 'Multiple devices and people online at the same time'), getListItem(GamingIcon, 'Offers nbn’s smoothest and most consistent gaming experience, even when others are online'), getListItem(VideoIcon, 'Enjoy seamless, high-quality video calls, even while downloading files or when others are online'), getListItem(FilesIcon, 'Faster downloading and uploading of large files')) : ___EmotionJSX(Fragment, null, getListItem(UhdIcon, '4K video streaming'), getListItem(ConcurrencyIcon, 'Multiple devices and people online at the same time'), getListItem(GamingIcon, 'Playing games online'), getListItem(VideoIcon, 'Smooth video calls even if others in your household are online'), getListItem(FilesIcon, 'Downloading large files')));
  return ___EmotionJSX(DesignSystemModal, {
    show: show,
    onClose: onClose,
    title: ___EmotionJSX("div", {
      css: styles.title
    }, "nbn\xAE connection"),
    fitContent: true,
    appearance: {
      mobile: 'fullscreen'
    },
    maxWidth: "620px"
  }, ___EmotionJSX("div", {
    css: styles.body
  }, isFast && getFastSection(), ___EmotionJSX("section", {
    css: styles.section
  }, ___EmotionJSX("div", {
    css: styles.heading
  }, "Technology type"), ___EmotionJSX("p", {
    css: styles.text
  }, "nbn Fixed Line connections utilise a physical line running to the premises (FTTP, HFC, FTTB, FTTC and FTTN). nbn\xAE Sky Muster\xAE Satellite and nbn Fixed Wireless are used mostly in regional and remote areas, where premises are spread out geographically over many square kilometres."), ___EmotionJSX("a", {
    css: styles.link,
    href: "https://www.nbnco.com.au/learn/network-technology?utm_source=domain&utm_medium=listings_panel&utm_campaign=domain_partnership&utm_content=tech",
    target: "_blank",
    rel: "noopener noreferrer"
  }, ___EmotionJSX("span", null, "Learn more about the technology"), ___EmotionJSX(ExternalLinkIcon, {
    css: styles.linkIcon
  }))), ___EmotionJSX("section", {
    css: styles.section
  }, ___EmotionJSX("div", {
    css: styles.heading
  }, "Speed"), ___EmotionJSX("p", {
    css: styles.text
  }, ___EmotionJSX("span", {
    css: styles.textBold
  }, "nbn "), ___EmotionJSX("span", null, "provides wholesale services to phone and internet providers.")), ___EmotionJSX("p", {
    css: styles.text
  }, ___EmotionJSX("span", {
    css: styles.textBold
  }, "nbn "), ___EmotionJSX("span", null, "wholesale speed tiers available to providers vary depending on the access technology in your area. To order a plan, contact your preferred phone and internet provider. Your experience may vary depending on factors such as your", ' '), ___EmotionJSX("span", {
    css: styles.textBold
  }, "nbn "), ___EmotionJSX("span", null, "access technology, internet provider, plan and equipment.")), ___EmotionJSX("p", {
    css: styles.text
  }, ___EmotionJSX("span", null, "Speeds may also be impacted by the number of concurrent users on the", ' '), ___EmotionJSX("span", {
    css: styles.textBold
  }, "nbn "), ___EmotionJSX("span", null, "Fixed Wireless network, including during busy periods. Satellite end customers may also experience latency.")), ___EmotionJSX("a", {
    css: styles.link,
    href: "https://www.nbnco.com.au/campaigns/more-speed?utm_source=domain&utm_medium=listings_panel&utm_campaign=domain_partnership&utm_content=speeds",
    target: "_blank",
    rel: "noopener noreferrer"
  }, ___EmotionJSX("span", null, "Learn more about speeds"), ___EmotionJSX(ExternalLinkIcon, {
    css: styles.linkIcon
  })))));
};
Modal.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func,
  brand: PropTypes.string,
  brandName: PropTypes.string
};
Modal.defaultProps = {
  show: false,
  onClose: () => {},
  brand: null,
  brandName: null
};
export default Modal;